export const formatSsn = (value, showSsn) => {
  if (!value) return "";
  const digits = value.replace(/[^\d]/g, "");

  if (showSsn) {
    // Show dashes only if showSsn is true
    if (digits.length <= 3) return digits;
    if (digits.length <= 5) {
      return digits.slice(0, 3) + "-" + digits.slice(3);
    }
    return (
      digits.slice(0, 3) + "-" + digits.slice(3, 5) + "-" + digits.slice(5)
    );
  } else {
    // If hidden, remove dashes so password field is only as long as the digits
    return digits;
  }
};
